import { useState, useEffect } from "react";
import { formatDateAndDay } from "../../../util/dateUtil";
import SlotApi from "../../../api/SlotApi";

const WaitingRankTd = ({ slotId, setCurRanks, setSlotProdNm }) => {
    useEffect(() => {
        const fetchSlot = timer => {		
			setTimeout(() => {
				SlotApi.getSlot(slotId, true).then(rslt => {
					if(rslt.slot) {
                        const { ranks, slotProdNm, slotCurRank } = rslt.slot;
                        if (slotProdNm) setSlotProdNm(slotProdNm);
                        if (slotCurRank) {
                            setCurRanks(ranks);
                            return;
                        }
					}
					timer /= 2;
					if (timer > 1000) {
						fetchSlot(timer);
					} 
				});
			}, timer);
		}

		fetchSlot(12000);
    }, []);
    
    return (
        <div class="rank-result-history rank-loading-overlay">
            <div className="loading-spinner" style={{ margin: 'auto' }}></div>
            <div className="loading-message">
                <span>순위 및 정보 조회 중입니다.<br/>잠시만 기다려 주세요.</span>
            </div>
        </div>
    );
}

const DEFUALT_SHOW_RANK_CNT = 16;
const MAX_SHOW_RANK_CNT = 100;

const getRankResultInfo = (type, rankBlogCafeReviewCnt, rankVisitorReviewCnt, rankSaveCnt, rankOrderCnt, rankStarPoint) => {
    if (type === 'ST001') {
        return (<>
            {rankSaveCnt && <li>{rankSaveCnt}</li>}
            <li>블 {rankBlogCafeReviewCnt || '-'}</li>
            <li>방 {rankVisitorReviewCnt || '-'}</li>
        </>)
    }
    if (type === 'ST002') {
        return (<>
            <li>리 {rankVisitorReviewCnt || '-'}</li>
            <li>구 {rankOrderCnt || '-'}</li>
            <li>찜 {rankSaveCnt || '-'}</li>
        </>)
    }
    if (type === 'ST007') {
        return (<>
            <li>리 {rankVisitorReviewCnt || '-'}</li>
            <li>별 {rankStarPoint || '-'}</li>
        </>)
    }
}

const RankTd = props => {
    const { ranks, slotId, type, setSlotProdNm } = props;
    const [ curRanks, setCurRanks ] = useState(null);
    const [ showRnakCnt, setShowRankCnt ] = useState(DEFUALT_SHOW_RANK_CNT);
    
    const handleToggleOpenClick = () => {
        setShowRankCnt(showRnakCnt === DEFUALT_SHOW_RANK_CNT ? MAX_SHOW_RANK_CNT : DEFUALT_SHOW_RANK_CNT);
    }   

    if (!curRanks && !ranks && slotId) 
        return <WaitingRankTd slotId={slotId} setCurRanks={setCurRanks} setSlotProdNm={setSlotProdNm} />;

    return (
        <>
            <div class="rank-result-history">
                {(curRanks || ranks).filter((r,i) => i < showRnakCnt).map(({rankDate, rankRank, rankBlogCafeReviewCnt, rankVisitorReviewCnt, rankSaveCnt, rankOrderCnt, rankStarPoint}) => {
                    const [ date, day ] = formatDateAndDay(rankDate);
                    return (
                        <div class="rank-result-item">
                            <p class="rank-result-day">{date} {day}</p>
                            <p class="rank-result-rank">{rankRank || '-'}위</p>
                            <ul class="rank-result-info">
                                {getRankResultInfo(type, rankBlogCafeReviewCnt, rankVisitorReviewCnt, rankSaveCnt, rankOrderCnt, rankStarPoint)}
                            </ul>
                        </div>
                    )
                })}
            </div>
            { (curRanks || ranks).length >= DEFUALT_SHOW_RANK_CNT && <button type="buttno" class="rank-result-button" onClick={handleToggleOpenClick}>
                <span>{showRnakCnt === DEFUALT_SHOW_RANK_CNT ? '펼치기' : '접기'}</span>
            </button>}
        </>
    )
}

export default RankTd